import blogApi from "../../../api/blog/blogApi";

const state = {};

const getters = {};

const mutations = {};

const actions = {

    getAllBlogPosts({ state }, { params, callback }) {
        console.log(state);
        blogApi.getAllBlogPostsApi({ params, callback }, res => {
            callback(res);
        });
    },
    getBlog({ state }, { params, callback }) {
        console.log(state);
        blogApi.getBlogPostApi({ params, callback }, res => {
            callback(res);
        });
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};



// WEBPACK FOOTER //
// ./src/store/modules/blog/blog.js